export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'alarmRuleName',
    align: 'left',
    minWidth: 200,
    title: '预警规则名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'sendType',
    align: 'center',
    width: 100,
    title: '推送方式',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'tableName',
    align: 'left',
    width: 100,
    title: '业务表单',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'tableColumnName',
    align: 'left',
    width: 100,
    title: '表单字段',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'matchCondition',
    align: 'left',
    width: 100,
    title: '匹配方式',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'matchValue',
    align: 'left',
    width: 150,
    title: '匹配值',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'sendWho',
    align: 'left',
    minWidth: 150,
    title: '通知范围',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'left',
    width: 100,
    title: '状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    title: '创建时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
